<!-- El formGroup se declara aquí porque este template vive dentro de un componente hijo. -->
<div
  class="form-row"
  *ngIf="ctx.isAedDeclaredCashin"
  [formGroup]="ctx.declarationCashinForm"
>
  <div class="filter-column">
    <div class="form-item">
      <label for="aed_cashin_firstname">Nombres</label>
      <input
        id="aed_cashin_firstname"
        type="text"
        placeholder="Ingresa los nombres"
        formControlName="firstname"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item">
      <label for="aed_cashin_lastname">Apellidos</label>
      <input
        id="aed_cashin_lastname"
        type="text"
        placeholder="Ingresa los apellidos"
        formControlName="lastname"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item">
      <label for="aed_cashin_account_id"
        >Número de cuenta<span class="required">*</span></label
      >
      <input
        id="aed_cashin_account_id"
        formControlName="account_id"
        pInputText
        class="id-input-filter"
        placeholder="UUID de la cuenta virtual"
      />
    </div>
  </div>

  <div class="filter-column">
    <div class="form-item">
      <label for="aed_cashin_purpose"
        >Descripción del pago<span class="required">*</span></label
      >
      <p-dropdown
        id="aed_cashin_purpose"
        formControlName="purpose"
        [options]="fusePayoutPurposeOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Propósito del pago"
        [filter]="true"
        filterBy="label,value"
        appendTo="body"
      />
    </div>

    <div class="form-item">
      <label for="aed_cashin_ext_ref">Referencia externa (opcional)</label>
      <input
        id="aed_cashin_ext_ref"
        formControlName="external_reference"
        pInputText
        class="id-input-filter"
        placeholder="Referencia para el proveedor"
      />
    </div>

    <div class="form-item">
      <label>Tipo beneficiario</label>
      <div class="account-type-picker">
        <div
          class="accu-type"
          [class.selected]="
            ctx.declarationCashinForm.controls.beneficiary_type.value ===
            'individual'
          "
          (click)="setBeneficiaryType('individual')"
        >
          Individual
        </div>
        <div
          class="accu-type"
          [class.selected]="
            ctx.declarationCashinForm.controls.beneficiary_type.value ===
            'corporate'
          "
          (click)="setBeneficiaryType('corporate')"
        >
          Business
        </div>
      </div>
    </div>
  </div>

  <div class="filter-column">
    <div class="form-item">
      <label for="aed_cashin_rail">Medio de pago al beneficiario</label>
      <p-dropdown
        id="aed_cashin_rail"
        formControlName="rail"
        [options]="railOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
      />
    </div>

    <div class="form-item" *ngIf="selectedRail === 'iban'">
      <label for="aed_cashin_iban"
        >IBAN beneficiario<span class="required">*</span></label
      >
      <input
        id="aed_cashin_iban"
        formControlName="iban"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item" *ngIf="selectedRail === 'wire'">
      <label for="aed_cashin_wire_account"
        >Wire número de cuenta<span class="required">*</span></label
      >
      <input
        id="aed_cashin_wire_account"
        formControlName="wire_account"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item" *ngIf="selectedRail === 'wire'">
      <label for="aed_cashin_wire_routing"
        >Wire routing<span class="required">*</span></label
      >
      <input
        id="aed_cashin_wire_routing"
        formControlName="wire_routing"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item">
      <label for="aed_cashin_addr_cc"
        >País dirección<span class="required">*</span></label
      >
      <p-dropdown
        id="aed_cashin_addr_cc"
        formControlName="address_country_code"
        [options]="ctx.countryOptions"
        optionLabel="name"
        optionValue="code"
        placeholder="País"
        [filter]="true"
        filterBy="name,code"
        appendTo="body"
      />
    </div>

    <div class="form-item">
      <label for="aed_cashin_line1"
        >Dirección línea 1<span class="required">*</span></label
      >
      <input
        id="aed_cashin_line1"
        formControlName="address_line_1"
        pInputText
        class="id-input-filter"
        maxlength="50"
        placeholder="Máx. 50 caracteres"
      />
    </div>
  </div>
</div>
